import { classNames } from '@panwds/tailwindcss';
import { useSpring, config, animated } from '@react-spring/web';
import React, { forwardRef, useRef, useState } from 'react';
import { metricsHelper } from '../../utils/metricsHelper.esm.js';
import { useNavigationContext } from '../NavigationContext/NavigationContext.esm.js';

const Submenu = forwardRef(({ children, id, otherWasOpen, isOpen, title }, ref) => {
    const el = useRef(null);
    const [expandedIsAnimating, setExpandingIsAnimating] = useState(false);
    const [collapsedIsAnimating, setCollapsedIsAnimating] = useState(false);
    const { collapsed } = useNavigationContext();
    const collapsedStyles = useSpring({
        immediate: otherWasOpen,
        onStart: 
        /* istanbul ignore next - animations are skipped in tests */
        () => setCollapsedIsAnimating(true),
        config: { ...config.stiff, clamp: true },
        to: { width: isOpen ? "13.5rem" : "0rem", translateX: "3.5rem", boxShadow: "10px 2px 16px -12px inset rgba(20, 26, 31, 0.88)" },
        onRest: 
        /* istanbul ignore next - animations are skipped in tests */
        () => setCollapsedIsAnimating(false),
    });
    const expandedStyles = useSpring({
        immediate: otherWasOpen,
        onStart: 
        /* istanbul ignore next - animations are skipped in tests */
        () => setExpandingIsAnimating(true),
        config: { ...config.stiff, clamp: true },
        to: { translateX: isOpen ? "0%" : "100%", width: "13.5rem", boxShadow: "10px 2px 16px -12px inset rgba(20, 26, 31, 0.88)" },
        onRest: 
        /* istanbul ignore next - animations are skipped in tests */
        () => setExpandingIsAnimating(false),
    });
    const normalizedId = metricsHelper(id);
    return (React.createElement(animated.nav, { style: collapsed ? collapsedStyles : expandedStyles, className: classNames("tw-absolute tw-box-border tw-border-solid tw-border-t-0 tw-border-b-0 tw-border-r-0 tw-border-0 tw-border-black tw-top-0 tw-h-full spf-nav-bg-bg tw-pl-2", "tw-overflow-x-hidden tw-overflow-y-auto tw-scrollbar-default tw-scrollbar-no-track dark:tw-scrollbar-thumb-dark dark:tw-scrollbar-corner-dark tw-transform tw-z-10", 
        /* istanbul ignore next - animations are skipped in tests */
        (!collapsedIsAnimating || !expandedIsAnimating) &&
            !isOpen &&
            "tw-sr-only", collapsed ? "tw-left-0 tw-z-10" : "tw-right-0 tw-z-20"), ref: el || ref, "aria-label": title, "data-metrics": `navigation-${normalizedId}-subnav`, "data-testid": isOpen ? `navigation-${normalizedId}-subnav` : undefined, "aria-hidden": !isOpen ? true : false, hidden: !isOpen ? true : false },
        React.createElement("div", null,
            React.createElement("div", { className: "tw-text-base w-box-border tw-px-2 tw-py-4 tw-border-none spf-nav-text-selected-color tw-font-semibold" }, title),
            React.createElement("ul", { className: "tw-box-border tw-list-none tw-m-0 tw-p-0 tw-b-0" }, children))));
});
Submenu.displayName = "Submenu";

export { Submenu };
//# sourceMappingURL=Submenu.esm.js.map
